export default __webpack_public_path__ + "1f415546c7a058945d269cf2c1793ff7.png";